/* Elle TENS - Uniformisation boutons (parite EXACTE avec la Home)
   Reconstruit les CTA custom (ancien dev) en vrais boutons du theme :
   memes classes (btn btn--primary btn--large btn--icon-solid) + meme
   structure interne (.btn__text + .btn__icon > .btn__icon-text + .btn__icon-icon)
   => l'animation text-swap native du theme s'applique a l'identique.
   Le remplacement de la classe custom detache le CSS de section
   (#shopify-section-X [class*="cta-btn"]) : aucun conflit, aucune double
   animation. Si ce script ne charge pas, le CSS fallback garde un rendu propre. */
(function () {
  var SVG =
    '<span class="icon icon--caret-right"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">' +
    '<path fill="none" d="M0 0H20V20H0V0z"></path>' +
    '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" ' +
    'stroke-width="var(--icon-stroke-width, 2)" d="M7.5 3.75L13.75 10L7.5 16.25"></path></svg></span>';

  var SEL = [
    '.submit-btn', '.eaf-cta-btn', '.etl-cta-btn', '.etf-btn', '.etap-cta-btn',
    '.etrv-cta-btn', '.ehc-cta-btn', '.elc__cta', '.exp-btn', '.philo__cta-btn'
  ].join(', ');

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function transform(el) {
    if (el.dataset.btnUniform) return;
    // [APPEL 29/07 #71] Si l'element enveloppe DEJA un bouton natif du theme
    // (.btn__text present, ex. birth-story rend 'button' avec text-swap), NE PAS
    // reconstruire : sinon on relit le libelle deja double par le text-swap et on
    // le re-duplique (libelle affiche 2x/4x). On laisse le bouton natif tel quel.
    if (el.querySelector('.btn__text, .btn__icon-text') || el.classList.contains('btn')) {
      el.dataset.btnUniform = '1';
      return;
    }
    var label = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!label) return;
    el.dataset.btnUniform = '1';
    el.setAttribute('data-uniform-from', (el.className || '').toString());
    // Remplace entierement les classes custom par celles du theme (detache le CSS de section)
    el.className = 'btn btn--primary btn--large btn--icon-solid';
    var e = esc(label);
    el.innerHTML =
      '<span class="btn__text">' + e + '</span>' +
      '<span class="btn__icon"><span class="btn__icon-text">' + e + '</span>' +
      '<span class="btn__icon-icon">' + SVG + '</span></span>';
  }

  function run(root) {
    try { (root || document).querySelectorAll(SEL).forEach(transform); } catch (err) {}
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', function () { run(); });
  // Re-applique apres rechargement d'une section (editeur de theme, AJAX)
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
